import { Input } from '@frontend/shadcn/components/ui/input';
import { PlusIcon, TrashIcon, AtIcon, XmarkIcon, CheckIcon } from '@revfluence/fresh-icons/solid/esm';
import React, { useState } from 'react';
import { AccordionContent, AccordionItem, AccordionTrigger } from '@frontend/shadcn/components/ui/accordion';
import { Button } from '@frontend/shadcn/components/ui/button';
import { Switch } from '@revfluence/fresh';
import { Checkbox } from '@frontend/shadcn/components/ui/checkbox';
import { CheckedState } from '@radix-ui/react-checkbox';
import { useRecruitment, useAmplifyHomePage, DEFAULT_AVAILABILITY_ITEMS } from '../RecruitmentContext';

export const AmplifyAvailabilitySection = () => {
  const {
    setAmplifyAvailabilityTitle,
    setAmplifyAvailabilityShowSection,
    addAmplifyAvailabilityListItem,
    removeAmplifyAvailabilityListItem,
    setAmplifyAvailabilityListItem
  } = useRecruitment();

  const homePage = useAmplifyHomePage();

  const [isAddingAvailability, setIsAddingAvailability] = useState(false);
  const [newAvailability, setNewAvailability] = useState('');

  if (!homePage) {
    return null;
  }

  const {
    title = '',
    listItems = [],
    showSection = true,
  } = homePage.availability || {};

  const handleUpdateAvailabilityItem = (index: number, text: string, checked: CheckedState) => {
    if (checked === 'indeterminate') {
      return;
    }
    setAmplifyAvailabilityListItem(index, { text, checked });
  };

  return (
    <AccordionItem value="availability" className="border-b-0">
      <AccordionTrigger>
        <div className="flex items-center gap-2 w-full">
          <div className="w-6 h-6 bg-red-4 rounded-lg text-primary-foreground flex items-center justify-center">
            <AtIcon fontSize={12} />
          </div>
          <span className="text-base font-medium">Availability</span>
          <div className="ml-auto mr-2 flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
            <Switch
              checked={showSection}
              onChange={(checked) => setAmplifyAvailabilityShowSection(checked)}
              size="small"
            />
          </div>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        {/* Title Section */}
        <div className="flex flex-col gap-2">
          <span className="text-primaryMuted font-normal text-xs">Select the social platforms this collaboration is available on (if applicable)</span>
          {showSection && (
            <>
              <div className="px-[1px]">
                <Input id="availability" placeholder="Available For" value={title} onChange={(e) => setAmplifyAvailabilityTitle(e.target.value)} />
              </div>
              {listItems?.map((item, index) => (
                <div key={index} className="flex gap-2 items-center">
                  <Checkbox id={`availability${item.text}`} checked={item.checked} onCheckedChange={(checked) => handleUpdateAvailabilityItem(index, item.text, checked)} />
                  <label htmlFor={`availability${item.text}`} className="text-sm">{item.text}</label>
                  {!DEFAULT_AVAILABILITY_ITEMS.includes(item.text) && (
                  <Button className="ml-auto" variant="ghost" size="xs" onClick={() => removeAmplifyAvailabilityListItem(item.text)}>
                    <TrashIcon className="text-destructive" />
                  </Button>
                      )}
                </div>
                  ))}
              {isAddingAvailability && (
              <div className="flex gap-2 items-center pl-[1px]">
                <Input placeholder="New List Item" value={newAvailability} onChange={(e) => setNewAvailability(e.target.value)} />
                <div className="flex gap-1 items-center">
                  <Button variant="ghost" size="xs" onClick={() => setIsAddingAvailability(false)}>
                    <XmarkIcon />
                  </Button>
                  <Button
                    variant="ghost"
                    size="xs"
                    onClick={() => {
                      addAmplifyAvailabilityListItem({ text: newAvailability, checked: true });
                      setIsAddingAvailability(false);
                      setNewAvailability('');
                    }}
                    disabled={!newAvailability.trim().length}
                  >
                    <CheckIcon />
                  </Button>
                </div>
              </div>
                  )}
              <Button
                variant="link"
                className="gap-2 pl-0 self-start"
                onClick={() => setIsAddingAvailability(true)}
                size="xs"
                disabled={isAddingAvailability}
              >
                <PlusIcon />
                Add List Item
              </Button>
            </>
          )}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
